// extracted by mini-css-extract-plugin
export default {"ribbon":"order-ribbon_ribbon__69Fj6","ribbon__item":"order-ribbon_ribbon__item__5K5Pz","ribbon__button":"order-ribbon_ribbon__button__ismUC"};